// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3VqFv","productName":"Table_productName__2SyFI"};